import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { OpenSwal } from '../../Utils';
import { useNavigate } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { url_get_invoice_details } from '../../RoutesMap';
import { apiWithAuth } from '../../Services/Axios/axios';


export default function RaiseInvoiceDefaultComp({ RaiseInvoiceCheckboxList, DefaultInvoiceHeaderNameSet }) {
  const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
  const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;

  const [AssignmentDetailsArrayAll, SetAssignmentDetailsArrayAll] = useState([]);
  const [InvoiceDetailsValues, SetInvoiceDetailsValues] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    let assign_ids_array = [];
    Object.keys(RaiseInvoiceCheckboxList).forEach(key => {
      if (RaiseInvoiceCheckboxList[key]) {
        assign_ids_array.push(key);
      }
    });

    let payload = {
      assign_ids: assign_ids_array
    };
    apiWithAuth.post(url_get_invoice_details, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
      if (response.data.status) {
        SetAssignmentDetailsArrayAll(response.data.data);
        SetInvoiceDetailsValues(response.data.invoice_details);
        DefaultInvoiceHeaderNameSet(response.data.invoice_details.new_invoice_name);
      } else if (response.data.status === false && response.data.message === "Token Expired") {
        OpenSwal('Token_error', navigate);
      } else {
        OpenSwal('Axios_error', response.data.message);
      }
    }).catch(response => {
      OpenSwal('Axios_error', response.message);
    });

  }, []);

  return (
    <>
      <Box mt={1.5} sx={{ position: 'absolute', left: 10, right: 10 }}>
        <Box sx={{ backgroundColor: 'white' }}>
          {Object.keys(InvoiceDetailsValues).length === 0 && <Box sx={{ mt: 5, mb: 5, height: 200, display: 'flex', alignItems: 'center' }}><LinearProgress color={appThemeSecondaryColor} sx={{ width: '100%' }} /></Box>}
          {Object.keys(InvoiceDetailsValues).length > 0 && <Box padding={1}>
            <Typography variant='body2'>Invoice No</Typography>
            <Typography variant='body2' color={appThemeColor}  >#{InvoiceDetailsValues.new_invoice_name}</Typography>
            <Typography variant='body2'>Invoice Date</Typography>
            <Typography variant='body2' color={appThemeColor}  >{InvoiceDetailsValues.new_invoice_date}</Typography>
            <Grid container spacing={1}>
              <Grid xs={6} sm={6} md={6}>
                <Typography variant='body2'>Suplier</Typography>
                <Box display='flex' alignItems='center'>
                  <Typography variant='body2' color={appThemeColor}  >{InvoiceDetailsValues.supplier_name}</Typography>
                  <Tooltip arrow enterTouchDelay={0} title={<Box>
                    <Typography variant='body2'>{InvoiceDetailsValues.supplier_name}</Typography>
                    <Typography variant='body2'>{InvoiceDetailsValues.supplier_address}</Typography> <Typography variant='body2'>{InvoiceDetailsValues.supplier_mobile}</Typography> <Typography variant='body2'>{InvoiceDetailsValues.supplier_email}</Typography>  </Box>} placement="top" >
                    <InfoOutlinedIcon sx={{ fontSize: { xs: '13px', sm: '14px', md: '16px' }, ml: 0.5, cursor: 'pointer' }} />
                  </Tooltip>
                </Box>
              </Grid>
              <Grid xs={6} sm={6} md={6}>
                <Typography variant='body2'>Bill to</Typography>
                <Box display='flex' alignItems='center'>
                  <Typography variant='body2' color={appThemeColor}  >{InvoiceDetailsValues.billing_name}</Typography>
                  <Tooltip arrow enterTouchDelay={0} title={<Box>
                    <Typography variant='body2'>{InvoiceDetailsValues.billing_name}</Typography>
                    <Typography variant='body2'>{InvoiceDetailsValues.billing_address}</Typography>
                    <Typography variant='body2' component={Link} href={'https://' + InvoiceDetailsValues.billing_link} target='_blank' color='inherit'>{InvoiceDetailsValues.billing_link}</Typography>  </Box>} placement="top" >
                    <InfoOutlinedIcon sx={{ fontSize: { xs: '13px', sm: '14px', md: '16px' }, ml: 0.5, cursor: 'pointer' }} />
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>}
        </Box>
        <Box mt={1} mb={30}>
          {AssignmentDetailsArrayAll.length === 0 && <Box sx={{ mt: 5, mb: 5, display: 'flex', justifyContent: 'center' }}><LinearProgress color={appThemeSecondaryColor} sx={{ width: '70%', alignItems: 'center' }} /></Box>}
          {AssignmentDetailsArrayAll.length > 0 &&
            <Box sx={{ overflow: 'auto' }}>
              <TableContainer sx={{ maxHeight: 300, minWidth: 280 }}>
                <Table stickyHeader size="small" >
                  <TableHead  >
                    <TableRow >
                      <TableCell align='center' sx={{ whiteSpace: 'nowrap', backgroundColor: appThemeColor, color: 'white', padding: 0.5 }} > #</TableCell>
                      <TableCell align='left' sx={{ backgroundColor: appThemeColor, color: 'white', padding: 0.5 }}> Description </TableCell>
                      <TableCell align='right' sx={{ backgroundColor: appThemeColor, color: 'white', padding: 0.5 }}> Amount in USD </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {AssignmentDetailsArrayAll.map((data, index) => {
                      let key_serial_no = index;
                      return (
                        <TableRow key={index}>
                          <TableCell align='center' sx={{ padding: 0.5, color: appThemeColor }} style={{ fontWeight: 'normal' }} >{++key_serial_no}</TableCell>
                          <TableCell sx={{ padding: 0.5 }} >
                            <Box  >
                              <Typography sx={{ typography: { xs: 'subtitle1', sm: 'body1' } }} color={appThemeColor}>{data.assign_orderid}</Typography>
                              <Typography sx={{ typography: { xs: 'subtitle2', sm: 'body2' } }} style={{ fontWeight: 'normal' }} >Order Date: {data.assign_order_date}</Typography>
                              <Typography sx={{ typography: { xs: 'subtitle2', sm: 'body2' } }} style={{ fontWeight: 'normal' }}>Timezone: {data.assign_timezone}</Typography>
                              <Typography sx={{ typography: { xs: 'subtitle2', sm: 'body2' } }} style={{ fontWeight: 'normal' }}>{data.assign_language}, {data.assign_service_type} for {data.assign_industry}</Typography>
                            </Box>
                          </TableCell>
                          <TableCell sx={{ padding: 2, color: appThemeColor }} style={{ fontWeight: 'normal' }} align='right'>$ {data.assign_amount}</TableCell>
                        </TableRow>)
                    })}

                  </TableBody>
                </Table>
              </TableContainer>
            </Box>}
        </Box>
      </Box>
    </>
  )
}

